export const getFirstLetter = (text) => {
  if(!text)
    return 'U';

  return text.substring(0, 1).toUpperCase();
};
